<button type="button" class="egl-header-button">
    <egl-icon [path]="icon" class="egl-header-button__icon" [width]="16" [height]="16"></egl-icon>
    {{ label }}
</button>
